import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const labelStyle = {
    margin: 0,
    fontSize: 'var(--fs-xs)',
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: 'var(--text-muted)',
};
const subStyle = {
    margin: 0,
    color: 'var(--text-muted)',
    fontSize: 'var(--fs-sm)',
    overflowWrap: 'anywhere',
};
export function KpiStrip({ label, children, minTileWidth = '13rem', className }) {
    if (!label || !label.trim())
        throw new Error('KpiStrip: `label` (the region’s accessible name) is required');
    return (_jsx("section", { "aria-label": label, className: className, "data-kpi-strip": true, style: {
            display: 'grid',
            gridTemplateColumns: `repeat(auto-fit, minmax(min(100%, ${minTileWidth}), 1fr))`,
            gap: '1px',
            background: 'var(--border)',
            border: '1px solid var(--border)',
            borderRadius: 'var(--radius-lg)',
            overflow: 'hidden',
            minWidth: 0,
        }, children: children }));
}
export function KpiTile({ label, value, valueSize = 'lg', of, valueExtra, sub, actions, children, id, tabIndex, className, }) {
    if (!label || !label.trim())
        throw new Error('KpiTile: `label` is required');
    const plain = typeof value === 'number' || typeof value === 'string';
    const subs = (Array.isArray(sub) ? sub : sub === undefined || sub === null || sub === false ? [] : [sub]).filter((s) => s !== null && s !== undefined && s !== false && s !== '');
    return (_jsxs("div", { id: id, tabIndex: tabIndex, className: className, "data-kpi-tile": true, style: {
            background: 'var(--surface)',
            padding: 'var(--sp-4)',
            display: 'grid',
            gap: 'var(--sp-2)',
            alignContent: 'start',
            minWidth: 0,
            fontFamily: 'var(--font-ui)',
        }, children: [_jsx("p", { style: labelStyle, "data-part": "kpi-label", children: label }), value !== undefined || of !== undefined || valueExtra !== undefined ? (_jsxs("p", { "data-part": "kpi-value", style: { margin: 0, display: 'flex', alignItems: 'baseline', gap: 'var(--sp-2)', flexWrap: 'wrap', color: 'var(--text)' }, children: [plain ? (_jsx("span", { "data-part": "kpi-num", style: valueSize === 'md'
                            ? { fontSize: 'var(--fs-md)', fontWeight: 600 }
                            : { fontSize: 'var(--fs-2xl)', fontWeight: 700, lineHeight: 1 }, children: value })) : value, of !== undefined && of !== null ? _jsx("span", { style: { color: 'var(--text-muted)', fontSize: 'var(--fs-sm)' }, children: of }) : null, valueExtra] })) : null, subs.map((s, i) => _jsx("p", { style: subStyle, "data-part": "kpi-sub", children: s }, i)), actions ? _jsx("div", { style: { display: 'flex', flexWrap: 'wrap', gap: 'var(--sp-2)', alignItems: 'center' }, children: actions }) : null, children] }));
}
//# sourceMappingURL=KpiTile.js.map